export type MasterDataHookOptions = {
  refreshIfEmpty?: boolean;
};

export function shouldUseMasterDataCache<T>(cached: T[] | null, refreshIfEmpty: boolean): boolean {
  if (cached === null) {
    return false;
  }
  if (cached.length === 0 && refreshIfEmpty) {
    return false;
  }
  return true;
}
